<div class="close-bid-dialog">
  <h2 mat-dialog-title>Close Bidding</h2>
  <p class="dialog-description">Bidding will be closed immediately. No further submissions will be accepted. All invitees will receive an email. You can add an optional message (e.g. reason or thank you).</p>

  <form [formGroup]="form" (ngSubmit)="onConfirm()">
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Comments / message to bidders (optional)</mat-label>
      <textarea matInput formControlName="comments" rows="4" placeholder="e.g. Thank you for your interest. We have received sufficient bids and are closing this round..."></textarea>
    </mat-form-field>
    <div mat-dialog-actions class="dialog-actions">
      <button mat-stroked-button type="button" (click)="onCancel()">Cancel</button>
      <button mat-raised-button color="warn" type="submit">Close Bid & Notify All</button>
    </div>
  </form>
</div>
